import React, { useCallback } from 'react';
import { Create, SimpleForm, PasswordInput, Loading,
    SaveButton, Toolbar,
    useCreate, useNotify,
    usePermissions, useTranslate,
    required, minLength } from 'react-admin';
import { Typography } from '@material-ui/core';

import { SectionTitle, Separator,
    validatePasswords } from './ui_components';
import { setFirstLogin } from '../authProvider';

const validates = [required(), minLength(8)];

const PasswordSaveButton = props => {
  const { resource } = props;
  const [create] = useCreate(resource);
  const notify = useNotify();

  const handleSave = useCallback(
    (values, redirect) => {
      create(
        {
          payload: { data: values },
        },
        {
          onSuccess: (params) => {
            setFirstLogin(false);
            notify('ra.notification.updated', 'info', { smart_count: 1 }, false);
            setTimeout(() => window.location = '/', 1000);
          },
          onFailure: (error) => {
            console.log(error);
            const message = error.message || 'ra.notification.data_provider_error'; 
            notify(message, 'warning');
          },
        }
      );
    },
    [create, notify]
  );

  // set onSave props instead of handleSubmitWithRedirect
  return <SaveButton {...props} onSave={handleSave} />;
};

const PasswordToolbar = props => (
  <Toolbar {...props}>
    <PasswordSaveButton />
  </Toolbar>
);

const PasswordFrom = props => {
  const translate = useTranslate();
  const { loading, loaded, permissions } = usePermissions();
  if (loading) {
    return (<Loading />);
  } else if (loaded && permissions && !permissions.isFirstLogin) {
    window.location = '/';
    return (<Loading />);
  }
  return (
    <Create {...props} title='Life is Tech! Lesson'>
      <SimpleForm validate={validatePasswords} redirect='/players' toolbar={<PasswordToolbar />}>
        <SectionTitle label="ra.auth.input_new_password" />
        <Separator />
        <Typography variant="body1">
          {translate("ra.validation.minLength", { min: 8 })}
        </Typography>
        <Separator />
        <PasswordInput source="password" validate={validates}/>
        <PasswordInput source="password_confirm" validate={validates}/>
      </SimpleForm>
    </Create>
  );
};

export default {
  create: PasswordFrom,
};
